import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { answerWithImageType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderRadioLikeButtonGroupWithImage } from '../../views/RadioLikeButtonGroupWithImage';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

import TotalFloorSpaceSmallPngPath from 'Images/me/pages/guest/proposals/new/total_floor_space/small.png'
import TotalFloorSpaceSmallWebPPath from 'Images/me/pages/guest/proposals/new/total_floor_space/small.webp'
import TotalFloorSpaceMediumPngPath from 'Images/me/pages/guest/proposals/new/total_floor_space/medium.png'
import TotalFloorSpaceMediumWebPPath from 'Images/me/pages/guest/proposals/new/total_floor_space/medium.webp'
import TotalFloorSpaceLargePngPath from 'Images/me/pages/guest/proposals/new/total_floor_space/large.png'
import TotalFloorSpaceLargeWebPPath from 'Images/me/pages/guest/proposals/new/total_floor_space/large.webp'
import TotalFloorSpaceUndefinedPngPath from 'Images/me/pages/guest/proposals/new/total_floor_space/undefined.png'
import TotalFloorSpaceUndefinedWebPPath from 'Images/me/pages/guest/proposals/new/total_floor_space/undefined.webp'

const SECTION_KEY_NAME = 'totalFloorSpace';
const PARAM_NAME = 'totalFloorSpace';
const GA_EVENT_NAME = 'totalFloorArea';

const textContentsTemplate = (text: string, subText?: string) => (
  <span css={css`display: inline-block; height: 2lh;`}>
    {text}<br />
    {subText && <span css={css`font-size: 0.8em;`}>{subText}</span>}
  </span>
);

export const totalFloorSpaceSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: answerWithImageType[] = [
    {
      value: '51～100㎡（15〜30坪）',
      textContents: textContentsTemplate('51～100㎡', '（15〜30坪）'),
      imagePaths: {
        imagePath: TotalFloorSpaceSmallPngPath,
        webp: TotalFloorSpaceSmallWebPPath,
      }
    },
    {
      value: '101～150㎡（30～45坪）',
      textContents: textContentsTemplate('101～150㎡', '（30～45坪）'),
      imagePaths: {
        imagePath: TotalFloorSpaceMediumPngPath,
        webp: TotalFloorSpaceMediumWebPPath,
      }
    },
    {
      value: '151～200㎡（45～60坪）',
      textContents: textContentsTemplate('151～200㎡', '（45～60坪）'),
      imagePaths: {
        imagePath: TotalFloorSpaceLargePngPath,
        webp: TotalFloorSpaceLargeWebPPath,
      }
    },
    {
      value: 'わからない',
      textContents: textContentsTemplate('わからない'),
      imagePaths: {
        imagePath: TotalFloorSpaceUndefinedPngPath,
        webp: TotalFloorSpaceUndefinedWebPPath,
      }
    },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        延べ床面積は、おおよそどのくらいでしょうか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderRadioLikeButtonGroupWithImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
